







































































































































































































































































































































































































































































































































import { Component, Emit, Prop, PropSync, Ref } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { InputAuthor } from '@/components/molecules/InputAuthor'
import { InputSubject } from '@/components/molecules/InputSubject'
import { InputSeries } from '@/components/molecules/InputSeries'
import { InputCompleteWorks } from '@/components/molecules/InputCompleteWorks'
import { InputPublisher } from '@/components/molecules/InputPublisher'
import InputCode from '@/components/molecules/InputCode/InputCode.vue'
import InputCodeNdcList from '@/components/molecules/InputCodeNdcList/InputCodeNdcList.vue'
import { AtomTextField } from '@/components/atoms'

export interface InputBasicSearchBibliographyItem {
  [key: string]: any
  title1: {
    input: string
    not: boolean
    errorMessage: string
  }
  title2: {
    input: string
    not: boolean
    errorMessage: string
  }
  titleInformation: boolean
  author1: {
    no: string
    not: boolean
    input: string
    errorMessage: string
  }
  author2: {
    no: string
    not: boolean
    input: string
    errorMessage: string
  }
  authorIds: {
    ids: []
    errorMessage: string
  }
  authorInformation: boolean
  subject1: {
    no: string
    not: boolean
    input: string
    errorMessage: string
  }
  subject2: {
    no: string
    not: boolean
    input: string
    errorMessage: string
  }
  subjectIds: {
    ids: []
    errorMessage: string
  }
  series: {
    no: string
    not: boolean
    input: string
    errorMessage: string
  }
  seriesIds: {
    ids: []
    errorMessage: string
  }
  completeWorks: {
    no: string
    not: boolean
    input: string
    errorMessage: string
  }
  completeWorksIds: {
    ids: []
    errorMessage: string
  }
  note: {
    input: string
    errorMessage: string
  }
  publisher: {
    no: string
    not: boolean
    input: string
    errorMessage: string
  }
  publisherIds: {
    ids: []
    errorMessage: string
  }
  volumeLabel: {
    not: boolean
    input: string
    errorMessage: string
  }
  classNo: {
    input: string
    errorMessage: string
  }
  publishedYearFrom: {
    input: string
    errorMessage: string
  }
  publishedYearTo: {
    input: string
    errorMessage: string
  }
  playbackTimeFrom: {
    input: string
    errorMessage: string
  }
  freeWord: {
    input: string
    errorMessage: string
  }
  playbackTimeTo: {
    input: string
    errorMessage: string
  }
  volume: {
    input: string
    errorMessage: string
  }
  volumeNumber: {
    input: string
    errorMessage: string
  }
  volumeTotal: {
    input: string
    errorMessage: string
  }
  dateLabel: {
    input: string
    errorMessage: string
  }
  genres: {
    input: string
    errorMessage: string
  }
  targetUsers: {
    input: string
    errorMessage: string
  }
  targetUsersAv: {
    input: string
    errorMessage: string
  }
}

export const defaultInputBasicSearchBibliographyItem = (): InputBasicSearchBibliographyItem => ({
  title1: {
    input: '',
    not: false,
    errorMessage: ''
  },
  title2: {
    input: '',
    not: false,
    errorMessage: ''
  },
  titleInformation: false,
  author1: {
    no: '',
    input: '',
    not: false,
    errorMessage: ''
  },
  author2: {
    no: '',
    input: '',
    not: false,
    errorMessage: ''
  },
  authorIds: {
    ids: [],
    errorMessage: ''
  },
  authorInformation: false,
  subject1: {
    no: '',
    input: '',
    not: false,
    errorMessage: ''
  },
  subject2: {
    no: '',
    input: '',
    not: false,
    errorMessage: ''
  },
  subjectIds: {
    ids: [],
    errorMessage: ''
  },
  series: {
    no: '',
    input: '',
    not: false,
    errorMessage: ''
  },
  seriesIds: {
    ids: [],
    errorMessage: ''
  },
  completeWorks: {
    no: '',
    input: '',
    not: false,
    errorMessage: ''
  },
  completeWorksIds: {
    ids: [],
    errorMessage: ''
  },
  note: {
    input: '',
    errorMessage: ''
  },
  publisher: {
    no: '',
    input: '',
    not: false,
    errorMessage: ''
  },
  publisherIds: {
    ids: [],
    errorMessage: ''
  },
  volumeLabel: {
    not: false,
    input: '',
    errorMessage: ''
  },
  classNo: {
    input: '',
    errorMessage: ''
  },
  publishedYearFrom: {
    input: '',
    errorMessage: ''
  },
  publishedYearTo: {
    input: '',
    errorMessage: ''
  },
  freeWord: {
    input: '',
    errorMessage: ''
  },
  playbackTimeFrom: {
    input: '',
    errorMessage: ''
  },
  playbackTimeTo: {
    input: '',
    errorMessage: ''
  },
  volume: {
    input: '',
    errorMessage: ''
  },
  volumeNumber: {
    input: '',
    errorMessage: ''
  },
  volumeTotal: {
    input: '',
    errorMessage: ''
  },
  dateLabel: {
    input: '',
    errorMessage: ''
  },
  genres: {
    input: '',
    errorMessage: ''
  },
  targetUsers: {
    input: '',
    errorMessage: ''
  },
  targetUsersAv: {
    input: '',
    errorMessage: ''
  }
})

const NOT_DEFAULT_COLOR: string = 'grey lighten-1'

const NOT_SELECTED_COLOR: string = '#4769CB'

const YEAR_MASK: string = '#'.repeat(4)

@Component({
  components: {
    InputCodeNdcList,
    InputCode,
    InputPublisher,
    InputAuthor,
    InputSubject,
    InputSeries,
    InputCompleteWorks
  }
})
export default class BibliographyBasicSearchBibliography extends ComponentVue {
  @Ref()
  title1TextField!: AtomTextField

  @Ref()
  inputAuthor1!: InputAuthor

  @Prop({ type: Boolean, default: false })
  tooliOnly!: boolean

  @PropSync('input', {
    type: Object,
    required: true
  })
  inputItem!: InputBasicSearchBibliographyItem

  get notDefaultColor(): string {
    return NOT_DEFAULT_COLOR
  }

  get notSelectedColor(): string {
    return NOT_SELECTED_COLOR
  }

  get yearMask(): string {
    return YEAR_MASK
  }

  get playbackTimeMask(): string {
    return '#'.repeat(4)
  }

  get volumeMask(): string {
    return '#'.repeat(4)
  }

  get volumeTotalMask(): string {
    return '#'.repeat(6)
  }

  get dateLabelMask(): string {
    return 'X'.repeat(12)
  }

  focus(): void {
    this.title1TextField.atomTextField.focus()
  }

  focusAuthor(): void {
    this.inputAuthor1.textField.atomTextField.focus()
  }

  colorOfNotIcon(bool: boolean): string {
    return bool ? this.notSelectedColor : this.notDefaultColor
  }

  existsErrorMessage(errorMessage: string): boolean {
    return !!errorMessage
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  toggleIconOfNot(obj: any): void {
    obj.not = !obj.not
  }

  onKeydownRightTitle1(): void {
    if (
      this.inputItem.title1.input.length > 0 &&
      this.title1TextField.atomTextField.$refs.input.selectionStart ===
        this.inputItem.title1.input.length
    ) {
      this.$emit('keydown:right:end:title1')
    }
  }

  @Emit('keydown:enter')
  onKeydownEnter(): void {}
}
